import { api } from '@/axios/instance/api';

export const fetchFxRates = () => {
  return api.get<Record<string, number>>('/employeesv2/fx-rates');
};
